<template>
    <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" class="h-dialog2 demandasd">
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
		    <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
		    <img src="../../assets/images/need.png" class="steps step1" v-if="status==1">
		    <img src="../../assets/images/need1.png" class="steps step2" v-if="status==2">
		    <img src="../../assets/images/need2.png" class="steps step3" v-if="status==3">
		    <div class="stepbtn" @click="nextStep(status)">
		        {{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
		    </div>
		    <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>选择需求类型</h1>
                    <p>Choose Style</p>
                </div>
            </div>
        </div>
        <div class="h-formLines" style="padding: 20px 30px;">
            <div class="xuqiuBoxList" style="margin-bottom: 0.5rem;">
                <div class="xuqiulist" :class="{'active':xuqiudex==index}" v-for="(item,index) in xuqiuList"
                     v-auth="'xuqiu_xinzeng'+index"
                     :key="index" @click="xuqiuGo(index)">
                    <p>{{item}}</p>
                    <img v-if="xuqiudex==index" src="../../assets/images/checkBox.png"
                         style="margin-left:20px;"/>
                </div>
            </div>
            <div class="xuqiutext"><span style="color:#f46071">*</span>信息获取是指销售人员在与客户沟通过程中收集到的产品购买意向，保留产品信息和预计购买金额。
            </div>
            <div class="xuqiutext"><span style="color:#f46071">*</span>采购需求是指用户有意向购买的产品属于海尔非自产产品，销售人员需要向采购部分人员发起采购产品需求。
            </div>
            <div style="display:flex;justify-content:center">
                <el-button class="h-btn h-formBtn h-bgblue2" @click="gotoxuqiu()">确定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
	import ss from "../../api/SystemService";
    export default {
        name: "demandAdd",
        data(){
            return {
				toshow:"demandAdd",
				checked:true,
				status:1,
				showOrhide:false,
                dialogFormVisible1:true,
                xuqiuList: ['信息获取', '采购需求'],
                xuqiudex: 0,
            }
        },
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
			// 新手引导页
			nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
						this.status = 3;
				}else if(this.status ==3){
					if(this.checked){
			           ss.salesList.toshow(this.toshow,this.checked).then(rd => {
			           	console.log(rd)
			           	this.showOrhide = false;
			           })
			        }else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}

				}
			},
			// 关闭新手引导页
			closeIt(){
			    this.showOrhide = false;
			    if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
			    }else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},
            xuqiuGo(index) {
                this.xuqiudex = index;
            },
            gotoxuqiu() {
                console.log(this.xuqiudex)
                if (this.xuqiudex == 0) {
                    this.$router.push('/xuqiu/xuqiuDetail')
                    this.dialogFormVisible1 = false;
                } else if (this.xuqiudex == 1) {
                    this.$router.push('/xuqiu/purchase')
                    this.dialogFormVisible1 = false;
                }
                this.$emit('imgfalse2');
            },
        },
		mounted() {

		},
		created() {
			this.showzhezhao()
		},
        props: {
            dialogVisible: {
                type: Boolean,
            },
        }
    }
</script>

<style scoped>
    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 0.75rem;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
        .step1{
        	top: 3.5rem;
        	left: 1.45rem;
        	width: 6.6rem;
        	height: 1.5rem;
        }
        .step2{
        	top: 3.55rem;
        	left: 8.1rem;
        	width: 3.6rem;
        	height: 2.6rem;
        }
        .step3{
        	top: 3.45rem;
        	left: 11.1rem;
        	width: 6.8rem;
        	height: 1.3rem;
        }
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
